import React from 'react';
import { View, Text } from 'react-native';
import { ScaledSheet } from '@utils/scale';

interface StatsCardProps {
  earningsPerOrder: {title: string, subtitle: string};
  totalOrders: {title: string, subtitle: string};
  totalEarnings: {title: string, subtitle: string};
}

/**
 * StatsCard Component
 * Displays key earnings statistics
 */
const StatsCard: React.FC<StatsCardProps> = ({
  earningsPerOrder,
  totalOrders,
  totalEarnings,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.statItem}>
        <Text style={styles.statValue}>{earningsPerOrder?.title}</Text>
        <Text style={styles.statLabel}>{earningsPerOrder?.subtitle}</Text>
      </View>

      <View style={styles.divider} />

      <View style={styles.statItem}>
        <Text style={styles.statValue}>{totalOrders?.title}</Text>
        <Text style={styles.statLabel}>{totalOrders?.subtitle}</Text>
      </View>

      <View style={styles.divider} />

      <View style={styles.statItem}>
        <Text style={styles.statValue}>{totalEarnings?.title}</Text>
        <Text style={styles.statLabel}>{totalEarnings?.subtitle}</Text>
      </View>
    </View>
  );
};

const styles = ScaledSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 8,
  },
  statItem: {
    flex: 1,
    alignItems: 'center',
  },
  statValue: {
    fontSize: 18,
    fontWeight: '700',
    color: '#000000',
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 12,
    color: '#666666',
    textAlign: 'center',
  },
  divider: {
    width: 1,
    height: 32,
    backgroundColor: '#E0E0E0',
    marginHorizontal: 8,
  },
});

export default StatsCard;


